import React from 'react';

class WidgetEchartConfig extends React.Component 
{
    static theme = {
        'default':{
            barConfig : {
                padding :'auto',
                appendPadding:15,
                color: '#006fc7',
                legend: false,
                scrollbar:false,
                maxBarWidth:25,
                yAxis: {
                    label: {
                        style:{
                            fontSize: 16,
                            fill: '#333333',
                            reversed:true,
                            position:'bottom',
                        },
                    },
                    visible: true,
                    formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
                  
                },
                xAxis: {
                    label: {
                        style:{
                            fontSize: 16,
                            fill: '#333333',
                        },
                    },
                },
                barStyle: function areaStyle() {
                    return { fill: 'l(135) 0:#03467b 1:#006fc7' };
                },
            },
            lineConfig : {
                
            },
            pieConfig : {
                padding : 'auto',
                //appendPadding: 10,
                colorField: 'type', // 部分图表使用 seriesField
                color: ['#3E9AE2', '#EA4D2B', '#FFCC4A', '#6FD886', '#03467B', '#D9492E', '#ED6F1A', '#E58433', '#ECC021', '#E4DA27', '#F3E852', '#FFF500', '#AAD24B', '#7DC153', '#66B967','#94D7D4','#B1F0ED','#62C8D6','#14A4B8','#007F90','#6687B9','#3C6AAE'],
                radius: 1,
                innerRadius: 0.75,
                legend: {
                    layout: 'vertical',
                    icon: "rect",
                    position: 'right',
                    offsetY: 0,
                    offsetX: -60,
                    itemHeight : 16,
                    pageNavigator: {
                        marker: {
                          style: {
                            // 非激活，不可点击态时的填充色设置
                            inactiveFill: '#000',
                            inactiveOpacity: 0.45,
                            // 默认填充色设置
                            fill: '#000',
                            opacity: 0.8,
                            size: 5,
                          },
                        },
                        text: {
                          style: {
                            fill: '#ccc',
                            fontSize: 12,
                          },
                        },
                      },
                    // textStyle: { fill: '#a3a9c1' }
                },
                label: undefined,
                interactions: [
                    { type: 'element-selected' }, 
                    { type: 'element-active' },
                    {
                        type: 'pie-statistic-active',
                        cfg: {
                        start: [
                            { trigger: 'element:mouseenter', action: 'pie-statistic:change' },
                            { trigger: 'legend-item:mouseenter', action: 'pie-statistic:change' },
                        ],
                        end: [
                            { trigger: 'element:mouseleave', action: 'pie-statistic:reset' },
                            { trigger: 'legend-item:mouseleave', action: 'pie-statistic:reset' },
                        ],
                        },
                    }
                ],
                // series: {
                //     emptyCircleStyle:{
                //         borderColor:'#fff'
                //     }
                // },
                statistic: {
                    title: {
                        offsetY: 30,
                    },
                    content: {
                        offsetY: -25
                    }
                },
            },
            wordCloudConfig : {

            },
            ringProgressConfig :{

            },
            progressConfig:{
                
            },
            dualAxesConfig :{
                //padding : [10,25,10,20],
                padding: 'auto',
                appendPadding : 25,
                autoFit: false,
                meta : {},
                legend : {
                },
                
                xAxis: {
                    label: {
                     style:{
                      fontSize: 16,
                      fill: '#333333',
                      },
                    },
                },
                area:{
                    position:{

                    }
                },
                geometryOptions: [
                {
                    geometry: 'column',
                    maxColumnWidth:25,
                    color: '#03467B',
                    columnWidthRatio: 0.4,
                    columnStyle: function areaStyle() {
                        return { fill: 'l(135) 0:#03467b 1:#006fc7' };
                    },
                },
                {
                    geometry: 'line',
                    color: '#FC8B40',
                    /**lineStyle: {
                        areaStyle: function areaStyle() {
                            return { fill: 'l(270) 0:#ffffff 0.5:#7ec2f3 1:#1890ff' };
                        },
                    },**/
                    // areaStyle: function areaStyle() {
                    //     return { fill: 'l(270) 0:#ffffff 0.5:#7ec2f3 1:#1890ff' };
                    // },
                    
                    seriesField: undefined,
                    
                },
                ],
                limitInPlot : false,     
            },
            columnConfig: {
                legend: {
                    layout: 'horizontal',
                    position: 'bottom'
                },
                height:400,
                padding: 'auto',
                appendPadding:25,
                color: ['#006fc7', ' #D9492E', '#269C86'],
                yAxis: {
                    label: {
                        style:{
                            fontSize: 16,
                            fill: '#333333',
                        },
                    },
                    visible: true,
                    formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
                },
                scrollbar:false,
                xAxis: {
                    label: {
                        formatter: (params) =>{
                            if( params.length > 9 )
                            {
                                return params.substring(0,8)+"...";
                            }
                            return params;
                        },
                        style:{
                            fontSize: 16,
                            fill: '#333333',
                        },
                        autoRotate: true 
                    } 
                },
                maxColumnWidth:25,
                
                columnStyle: function areaStyle() {
                    return { fill: 'l(135) 0:#03467b 1:#006fc7' };
                },
            },
            areaConfig:{   
                //padding: [60, 50, 50, 50],
                appendPadding:25,
                color: ['#006fc7', ' #D9492E', '#269C86'],
                yAxis: {
                    label: {
                        style:{
                            fontSize: 16,
                            fill: '#333333',
                        },
                    },
                    visible: true,
                },
                areaStyle: function areaStyle() {
                    return { fill: 'l(270) 0.26:#FD8C40 1:#D9492E' };
                },
                point: {
                    size: 5,
                    shape: 'hollowPie',
                    // style: {
                    //     fill: '#fff',
                    //     stroke: '#D9492E',
                    //     lineWidth: 2,
                    // },
                },
                tooltip: {
                    show:true,
                },
                // state: {
                //     active: {
                //         style: {
                //             color:'#D9492E',
                //             shadowBlur: 4,
                //             stroke: '#D9492E',
                //             fill: '#fff',
                //         },
                //     },
                // },
                // theme: {
                //     geometries: {
                //         point: {
                //             diamond: {
                //                 active: {
                //                     style: {
                //                         color:'#D9492E',
                //                         shadowColor: '#D9492E',
                //                         shadowBlur: 2,
                //                         stroke: '#D9492E',
                //                     }
                //                 }
                //             }
                //         }
                //     }
                // },
                // yAxis:{
                //     line:{
                //         style:{
                //             stroke:'#BABABA'
                //         }
                //     }
                // },
                //interactions: [{ type: 'marker-active' }],
            },
            sunburstConfig:{
                tooltip:{
                    show:true,
                    trigger: 'item' ,
                    backgroundColor:'#fff',
                    padding: 10 ,
                    textStyle: {
                        color: '#8d8d8d' ,
                        fontSize: 12 ,
                    }
                },
                color:["#03467b",
                    "#269c86",
                    "#d9492e",
                    "#ED6F1A",
                    "#E58433",
                    "#ecc021",
                    "#e4da27"],
                    
                series: {
                    type: 'sunburst',
                    label:{
                        show:false,
                    },
                    radius: [0, '95%'],
                    sort: null,
                    emphasis: {
                        focus: 'ancestor'
                    },
                    blur: {
                        itemStyle:
                        {
                            opacity:0.2
                        },
                        label: {
                            minAngle :true,
                            opacity:0.2
                        }
                    },
                    levels: [{}, {
                        r0: '15%',
                        r: '35%',
                        itemStyle: {
                            borderWidth: 0.5
                        },
                        label: {
                            rotate: 'tangential'
                        }
                    }, {
                        r0: '35%',
                        r: '50%',
                        itemStyle: {
                            opacity:0.9
                        },
                        label: {
                            align: 'right'
                        }
                    }, {
                        r0: '50%',
                        r: '65%',
                        label: {
                            position: 'outside',
                            padding: 0.5,
                            silent: false
                        },
                        itemStyle: {
                            borderWidth: 0.5,
                            opacity:0.8
                        }
                    },{
                        r0: '65%',
                        r: '75%',
                        label: {
                            position: 'outside',
                            padding: 0.5,
                            silent: false
                        },
                        itemStyle: {
                            borderWidth: 0.5,
                            opacity:0.75
                        }
                    },{
                        r0: '75%',
                        r: '80%',
                        label: {
                            position: 'outside',
                            padding: 0.5,
                            silent: false
                        },
                        itemStyle: {
                            borderWidth: 0.5,
                            opacity:0.7
                        }
                    }]
                }
            },
            bidirectionalBarConfig:{
                appendPadding: 30,
                interactions: [{ type: 'active-region' }],
                xAxis: { position: 'bottom' },
                tooltip: {
                    shared: true,
                    showMarkers: false,
                },
              
            },
            scatterConfig:{
                appendPadding: 20,
                color: ['#c71e1d', '#ffca76', '#09bb9f'],
                size: [4, 30],
                yAxis: {
                    nice: true,
                    line: { style: { stroke: '#aaa' } },
                },
                xAxis: {
                grid: { line: { style: { stroke: '#eee' } } },
                line: { style: { stroke: '#aaa' } },
                },
                label: {},
                shape: 'circle',
                pointStyle: {
                    fillOpacity: 0.8,
                    stroke: '#bbb',
                },
            },
            mapScatterConfig:{
                geo: {
                    show: true,
                    roam: true,
                    label: {
                        emphasis: {
                            show: true
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: '#2776B4',
                            borderColor: '#fff',
                            shadowColor: '#1773c3',
                            shadowBlur: 20
                        }
                    }
                },
                series:[{
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    symbolSize: function (val) {
                        if( val[2] / 10 <= 5)
                        {
                            return 5;
                        }
                        return val[2] / 10;
                    },
                    tooltip:{
                        backgroundColor:'#fff',
                        padding: 10 ,
                        textStyle: {
                            color: '#8d8d8d' ,
                            fontSize: 12 ,
                        }
                    },
                    /*
                    label: {
                        show:true,
                        color:"#ED6F1A",
                        normal: {
                            formatter: '{b}',
                            position: 'right',
                            show: false
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    */
                    itemStyle: {
                        normal: {
                            color: '#ddb926'
                        }
                    },
                }]
            },
            timeScatterConfig: {
                baseOption: {
                    grid: {
                        bottom: 100,
                    },
                    timeline: {
                        axisType: 'category',
                        orient: 'horizontal',
                        autoPlay: true,
                        playInterval: 1000,
                        bottom: 20,
                        height: 55,
                        symbol: 'none',
                        checkpointStyle: {
                            borderWidth: 2
                        },
                        controlStyle: {
                            showNextBtn: false,
                            showPrevBtn: false
                        },
                        data: []
                    },
                    tooltip: {
                        padding: 5,
                        borderWidth: 1,
                    },
                    xAxis: {
                        type: 'value',
                        nameGap: 25,
                        nameLocation: 'middle',
                        nameTextStyle: {
                            fontSize: 18
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: 'value',
                        nameTextStyle: {
                            fontSize: 18
                        },
                        splitLine: {
                            show: false
                        },
                    },
                    visualMap: [
                        {
                            show: false,
                            dimension: 3,
                            calculable: true,
                            precision: 0.1,
                            textGap: 30,
                            textStyle: {
                                color: '#ccc'
                            },
                            inRange: {
                                color: (function () {
                                    var colors = ['#51689b', '#ce5c5c', '#fbc357', '#8fbf8f', '#659d84', '#fb8e6a', '#c77288', '#786090', '#91c4c5', '#6890ba'];
                                    return colors.concat(colors);
                                })()
                            }
                        }
                    ],
                    series: [
                        {
                            type: 'scatter',
                            itemStyle: {
                                opacity: 0.8
                            },
                           
                        }
                    ],
                    animationDurationUpdate: 1000,
                    animationEasingUpdate: 'quinticInOut'
                },
                options: []
            },
            mapFlowConfig : {
                tooltip: {
                    triggerOn: "onmousemove",
                },
                geo: {
                    map: 'china',
                    roam: true,
                    zoom: 1.3,
                    //调整以下3个配置项与页面地图重合
                    // aspectScale: 1,			//echarts地图的长宽比（就是胖瘦）
                    // center: [104.29, 35.8], //设置可见中心坐标，以此坐标来放大和缩小
                    // zoom: 1.00, //放大级别
                    // roam:true,
                    label: {
                        show: false
                    },
                    itemStyle: {
                        normal: {
                            borderColor: '#BABABA',
                            borderWidth: 1,
                            areaColor: '#2675B3',
                        },
                        emphasis: {
                            areaColor: '#2675B3',
                            borderWidth: 0
                        }
                    },
                    emphasis: {
                        label: {
                            show: false,
                        }
                    }

                },
                series: [
                    {
                        type: 'lines',
                        zlevel: 2,
                        effect: {
                            show: true,
                            period: 3, //箭头指向速度，值越小速度越快
                            trailLength: 0.4, //特效尾迹长度[0,1]值越大，尾迹越长重
                            symbol: 'arrow', //箭头图标
                            symbolSize: 5, //图标大小
                        },
                        lineStyle: {
                            normal: {
                                color: {
                                    type: 'linear',
                                    x: 1,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0,
                                        color: 'rgba(255,67,67,0.1)' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: 'rgba(255,67,67,1)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                },
                                width: 1, //线条宽度
                                opacity: 0.1, //尾迹线条透明度
                                curveness: .3 //尾迹线条曲直度
                            },
                            emphasis: {
                                width: 3,
                                opacity: 0.5,
                            }
                        },
                        data: []
                    }
                ]
            },
            radarConfig : {
                smooth : false,
                area: {
                    color:"#DA4221"
                },
                color :"#DA4221",
                lineStyle : {
                    fill:"#DA4221",
                    fillOpacity : 0.2
                }
            }
        },
        'TH001':{
            pieConfig : {
                padding : 'auto',
                //appendPadding: 10,
                colorField: 'type', // 部分图表使用 seriesField
                //color: ['#EA4D2B','#FFA14A','#FFCC4A','#6FD886', '#03467B', '#D9492E', '#ED6F1A', '#E58433', '#ECC021', '#E4DA27', '#F3E852', '#FFF500', '#AAD24B', '#7DC153', '#66B967','#94D7D4','#B1F0ED','#62C8D6','#14A4B8','#007F90','#6687B9','#3C6AAE'],
                color: ['#ee6364', '#016eff', '#EA4D2B','#FFA14A'],
                radius: 0.85,
                innerRadius: 0.8,
                //legend:false,
                legend: {

                    layout: 'horizontal',
                    position: 'bottom',
                    offsetY: 0,
                    offsetX: 0,
                    itemHeight : 16,
                    pageNavigator: {
                        marker: {
                          style: {
                            // 非激活，不可点击态时的填充色设置
                            inactiveFill: '#000',
                            inactiveOpacity: 0.45,
                            // 默认填充色设置
                            fill: '#000',
                            opacity: 0.8,
                            size: 5,
                          },
                        },
                        text: {
                          style: {
                            fill: '#ccc',
                            fontSize: 12,
                          },
                        },
                      },
                    // textStyle: { fill: '#a3a9c1' }
                },
                label: undefined,
                interactions: [
                    { type: 'element-selected' }, 
                    { type: 'element-active' },
                    {
                        type: 'pie-statistic-active',
                        cfg: {
                        start: [
                            { trigger: 'element:mouseenter', action: 'pie-statistic:change' },
                            { trigger: 'legend-item:mouseenter', action: 'pie-statistic:change' },
                        ],
                        end: [
                            { trigger: 'element:mouseleave', action: 'pie-statistic:reset' },
                            { trigger: 'legend-item:mouseleave', action: 'pie-statistic:reset' },
                        ],
                        },
                    }
                ],
                statistic: {
                    title: {
                        offsetY: 30,
                        style: {
                            fontSize:14,
                            fontFamily:'PingFangSC',
                            color: '#323232',
                        },
                    },
                    content: {
                        offsetY: -25,
                        style: {
                            fontFamily: 'PingFangSC',
                            color: '#000000',
                            fontWeight:400,
                            fontSize:36,
                        },
                    }
                },
            },
        },
    }
}

export default WidgetEchartConfig